import { Controller } from "@hotwired/stimulus"

// Submits the controller's <form> in response to a `change` event on any
// input that targets `auto-submit#submit`. Mount on the form:
//
//   <form data-controller="auto-submit">
//     <select data-action="change->auto-submit#submit">…</select>
//   </form>
//
// Useful for tiny filter forms where every change should reload the page.
export default class extends Controller<HTMLFormElement> {
  submit() {
    this.element.requestSubmit()
  }
}
